import React from "react";
import { makeStyles } from '@material-ui/styles';
import BackButton from "../../../../base/buttons/back_button.js";

const blockStyles = makeStyles(theme => ({
  root: {
    margin: "0 0 70px",
    ['@media (max-width: 768px)']: {
      margin: "52px -5px 0px"
    }
  }
}));

const BackButtonBlock = props => {
  const classes = blockStyles()

  return (
    <div className = { classes.root } >
      <BackButton />
    </div>
  )  
}
export default BackButtonBlock